import { render, staticRenderFns } from "./TiptapInput.vue?vue&type=template&id=6fca79af"
import script from "./TiptapInput.vue?vue&type=script&lang=js"
export * from "./TiptapInput.vue?vue&type=script&lang=js"
import style0 from "./TiptapInput.vue?vue&type=style&index=0&id=6fca79af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports